/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { pbapiCreateUserResponse } from '../models/pbapiCreateUserResponse';
import type { pbapiDeleteUserResponse } from '../models/pbapiDeleteUserResponse';
import type { pbapiGetHealthcheckResponse } from '../models/pbapiGetHealthcheckResponse';
import type { pbapiGetMetadataResponse } from '../models/pbapiGetMetadataResponse';
import type { pbapiGetUserResponse } from '../models/pbapiGetUserResponse';
import type { pbapiGetUsersResponse } from '../models/pbapiGetUsersResponse';
import type { pbapiUpdateUserResponse } from '../models/pbapiUpdateUserResponse';
import type { rpcStatus } from '../models/rpcStatus';
import type { users_email_body } from '../models/users_email_body';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ServiceService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns pbapiGetHealthcheckResponse A successful response.
     * @returns rpcStatus An unexpected error response.
     * @throws ApiError
     */
    public serviceGetHealthcheck(): Observable<pbapiGetHealthcheckResponse | rpcStatus> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/healthcheck',
        });
    }
    /**
     * @returns pbapiGetMetadataResponse A successful response.
     * @returns rpcStatus An unexpected error response.
     * @throws ApiError
     */
    public serviceGetMetadata(): Observable<pbapiGetMetadataResponse | rpcStatus> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/metadata',
        });
    }
    /**
     * @returns pbapiGetUsersResponse A successful response.
     * @returns rpcStatus An unexpected error response.
     * @throws ApiError
     */
    public serviceGetUsers(): Observable<pbapiGetUsersResponse | rpcStatus> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/users',
        });
    }
    /**
     * @param email
     * @returns pbapiGetUserResponse A successful response.
     * @returns rpcStatus An unexpected error response.
     * @throws ApiError
     */
    public serviceGetUser(
        email: string,
    ): Observable<pbapiGetUserResponse | rpcStatus> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/users/{email}',
            path: {
                'email': email,
            },
        });
    }
    /**
     * @param email
     * @param requestBody
     * @returns pbapiUpdateUserResponse A successful response.
     * @returns rpcStatus An unexpected error response.
     * @throws ApiError
     */
    public serviceUpdateUser(
        email: string,
        requestBody: users_email_body,
    ): Observable<pbapiUpdateUserResponse | rpcStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/users/{email}',
            path: {
                'email': email,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param email
     * @param requestBody
     * @returns pbapiCreateUserResponse A successful response.
     * @returns rpcStatus An unexpected error response.
     * @throws ApiError
     */
    public serviceCreateUser(
        email: string,
        requestBody: Record<string, any>,
    ): Observable<pbapiCreateUserResponse | rpcStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/users/{email}',
            path: {
                'email': email,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param email
     * @returns pbapiDeleteUserResponse A successful response.
     * @returns rpcStatus An unexpected error response.
     * @throws ApiError
     */
    public serviceDeleteUser(
        email: string,
    ): Observable<pbapiDeleteUserResponse | rpcStatus> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/users/{email}',
            path: {
                'email': email,
            },
        });
    }
}
